<template>
  <div class="loader-overlay">
    <div class="loader-container">
      <div class="loader"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoaderPage',
  created() {
    // Close this window after a short delay
    setTimeout(() => {
      window.close();
    }, 1000);
  },
  mounted() {
    // Prevent scrolling on the body
    document.body.style.overflow = 'hidden';
  },
  beforeUnmount() {
    // Restore scrolling when component is destroyed
    document.body.style.overflow = '';
  }
}
</script>

<style scoped>
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #f9f9f9;
  z-index: 9999;
}

.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.loader {
  width: 48px;
  height: 48px;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style> 